import { Card, CardBody, CardHeader } from '@heroui/react';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { Patient } from '@/patient-app-common/types/Patient';

interface PostopCardProps {
  patient: Patient;
  dischargeDate: Dayjs | null;
  startOfDayInHospitalTz: Dayjs | null;
}

export function PostopCard({
  patient,
  dischargeDate,
  startOfDayInHospitalTz,
}: PostopCardProps) {
  const { t } = useTranslation('home');

  const { daysPostOp, firstName, othersUsingApp } = patient;
  const headerText = othersUsingApp
    ? t('common.text.greeting_name_indirect', { firstName })
    : t('common.text.greeting_name', { firstName });

  const daysAtHome =
    dayjs(startOfDayInHospitalTz).diff(dayjs(dischargeDate), 'days') + 1;

  return (
    <>
      <Card shadow="none" className="bg-transparent px-0">
        <CardHeader className="px-0">
          <h1 className="text-2xl">{headerText}</h1>
        </CardHeader>
        <CardBody className="px-0">
          <h2 className="font-light">
            {t('postopcard.countdown', { daysAtHome, daysPostOp })}
          </h2>
          <p className="font-light">{t('postopcard.description')}</p>
        </CardBody>
      </Card>
    </>
  );
}
